import React from 'react';

type PaginationContextType = {
  searchText: string;
};

const paginationContextDefaultProps: PaginationContextType = {
  searchText: '',
};

export const PaginationContext = React.createContext<PaginationContextType>({
  ...paginationContextDefaultProps,
});

export const usePaginationContext = (): PaginationContextType =>
  React.useContext(PaginationContext);
